import React from 'react';
import { X, Check } from 'lucide-react';
const rows = [{
  situation: 'Entendés el sistema',
  without: '✅',
  with: '✅'
}, {
  situation: 'Recursos editables listos',
  without: '❌',
  with: '✅'
}, {
  situation: 'Improvisás menos',
  without: '⚠ parcialmente',
  with: '✅'
}, {
  situation: 'Implementás más rápido',
  without: '❌',
  with: '✅'
}, {
  situation: 'Mejorás experiencia clienta',
  without: '⚠',
  with: '✅'
}, {
  situation: 'Orden operativo',
  without: '⚠',
  with: '✅'
}, {
  situation: 'Herramientas listas',
  without: '❌',
  with: '✅'
}, {
  situation: 'Reducís desgaste diario',
  without: '⚠',
  with: '✅'
}];
export function ComparisonTable() {
  return <section className="bg-white py-8 px-5" data-id="element-54">
      <div className="max-w-xl mx-auto" data-id="element-55">
        <h2 className="text-2xl md:text-3xl font-black text-center text-slate-900 mb-12" data-id="element-56">
          LA DIFERENCIA ES CLARA
        </h2>

        <div className="bg-slate-50 border border-slate-100 rounded-3xl overflow-hidden mb-12 shadow-sm" data-id="element-57">
          <div className="grid grid-cols-3 text-center text-[10px] font-black uppercase tracking-widest border-b border-slate-100" data-id="element-58">
            <div className="p-4 text-slate-400 bg-white" data-id="element-59">Situación</div>
            <div className="p-4 text-red-500 bg-red-50/50" data-id="element-60">SOLO MEGAPACK</div>
            <div className="p-4 bg-brand-primary/10 text-brand-primary" data-id="element-61">
              SISTEMA COMPLETO
            </div>
          </div>
          {rows.map((row, idx) => <div key={idx} className="grid grid-cols-3 text-center border-b border-slate-100 last:border-b-0" data-id="element-62">
              <div className="p-5 text-xs font-bold text-slate-500 flex items-center justify-center bg-white" data-id="element-63">
                {row.situation}
              </div>
              <div className="p-5 bg-red-50/20 flex flex-col items-center justify-center gap-2" data-id="element-64">
                <span className="text-[11px] text-slate-400 font-bold italic" data-id="element-65">
                  {row.without}
                </span>
              </div>
              <div className="p-5 bg-brand-primary/5 flex flex-col items-center justify-center gap-2" data-id="element-66">
                <span className="text-[11px] text-slate-900 font-black" data-id="element-67">
                  {row.with}
                </span>
              </div>
            </div>)}
        </div>
        <p className="text-center text-slate-500 font-medium text-sm" data-id="element-68">
          La pregunta no es si el sistema completo tiene más valor. Eso es
          evidente. <br data-id="element-69" />
          La pregunta es:{' '}
          <span className="font-bold text-brand-primary" data-id="element-70">
            ¿querés solo entender cómo trabajar mejor… o realmente empezar a
            hacerlo?
          </span>
        </p>
      </div>
    </section>;
}